import PropTypes from "prop-types";
import { forwardRef, useImperativeHandle, useState } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";
import AppMap from "./AppMap";
import { Badge } from "./ui/badge";

const GOOGLE_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

const MapModal = forwardRef(({ hasAddresses = false }, ref) => {
  const [open, setOpen] = useState(false);
  const [modelType, setModelType] = useState(null);
  const [modelId, setModelId] = useState(null);
  const [locationType, setLocationType] = useState(null);
  const [name, setName] = useState(null);

  const [locations, setLocations] = useState([]);

  function handleOpen(data) {
    setLocationType(data.locationType || "wifi");
    setModelType(data.modelType);
    setModelId(data.modelId);
    setName(data.name);
    if (data.locations) setLocations(data.locations);
    return setOpen(true);
  }

  function handleClose() {
    setLocations([]);
    setModelType(null);
    setModelId(null);
    setOpen(false);
  }

  useImperativeHandle(ref, () => ({
    open: handleOpen,
  }));

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) handleClose();
      }}
    >
      <DialogContent className="tw:sm:max-w-7xl">
        <DialogHeader>
          <DialogTitle>
            <div className="tw:flex tw:items-center tw:gap-4">
              <div>Nearby Events for {name || `${modelType} ${modelId}`}</div>
              {modelType === "Machine" && <Badge>{locationType}</Badge>}
            </div>
          </DialogTitle>
        </DialogHeader>
        <APIProvider apiKey={GOOGLE_API_KEY}>
          <AppMap
            modelId={modelId}
            modelType={modelType}
            locationType={locationType}
            hasAddresses={hasAddresses}
            locations={locations}
          />
        </APIProvider>
      </DialogContent>
    </Dialog>
  );
});

MapModal.propTypes = {
  hasAddresses: PropTypes.bool,
};

export default MapModal;
